/**
 * nordura-before-after-slider.js
 * <before-after-slider> — a draggable reveal slider used on the "Vorteile"
 * tab. Pointer-events based so it works with mouse, touch, and pen alike.
 */
(function () {
  'use strict';

  if (customElements.get('before-after-slider')) return;

  class BeforeAfterSlider extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('[data-n-slider-frame]');
      this.clip = this.querySelector('[data-n-slider-clip]');
      this.handle = this.querySelector('[data-n-slider-handle]');
      if (!this.frame || !this.clip) return;

      this.setPercent(50);
      this.frame.addEventListener('pointerdown', this.onPointerDown.bind(this));
    }

    setPercent(pct) {
      pct = Math.max(4, Math.min(96, pct));
      this.clip.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      if (this.handle) this.handle.style.left = pct + '%';
    }

    onPointerDown(e) {
      e.preventDefault();
      this.updateFromEvent(e);
      var move = this.updateFromEvent.bind(this);
      var up = function () {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
      };
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
    }

    updateFromEvent(e) {
      var rect = this.frame.getBoundingClientRect();
      var pct = ((e.clientX - rect.left) / rect.width) * 100;
      this.setPercent(pct);
    }
  }

  customElements.define('before-after-slider', BeforeAfterSlider);
})();
